import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { DATA_MODAL_TOMATE_TIEMPO_SALIR } from "src/app/core/components/modal/constants";
import { IAppState } from "src/app/store/states/app.state";
import { DataModal } from "src/assets/interfaces/interfaces.state";
import { transformDateExpire } from "../../../utils/utils";
import { MantenimientosService } from "src/app/services/mantenimientos.service";
import { Subscription } from "rxjs";

declare let KAMPYLE_ONSITE_SDK: any;
const ZERO = 0;
const ENCUESTA_TIMEOUT_MS = 2000;

@Component({
	selector: "app-modal-salir",
	templateUrl: "./modal-salir.component.html"
})
export class ModalSalirComponent implements OnInit {
	private _open: boolean = false;
	@Output() closeModal = new EventEmitter<string>();
	public dataxModalCancelar: DataModal = DATA_MODAL_TOMATE_TIEMPO_SALIR;
	public expirationDate: string = "";
	public documentNumber: string = "";
	encuestaEjecutada: boolean = false;
	private subscriptor: Subscription;

	@Input()
	set open(value: boolean) {
		this.getExpirationDate();
		setTimeout(() => {
			if (document.location.href.includes("firmaelectronica")) {
				this.dataxModalCancelar.tex1 =
					"Retoma el proceso cuando quieras.";
				this.dataxModalCancelar.tex1Part2 = "";
				this.dataxModalCancelar.tex1Part3 =
					"Guardaremos tu información.";
			} else {
				this.dataxModalCancelar.tex1 = "Estas alternativas ";
				this.dataxModalCancelar.tex1Part2 =
					"estarán esperando por ti hasta el " + this.expirationDate;
				this.dataxModalCancelar.tex1Part3 =
					" por si cambias de opinión.";
			}
		});

		this._open = value;
	}
	get open(): boolean {
		return this._open;
	}

	constructor(
		private readonly _store: Store<IAppState>,
		private readonly mantenimientosService: MantenimientosService
	) {}
	ngOnInit(): void {
		this.getDocument();
		this.mantenimientosService.encuestaEjecutada$.subscribe((estado) => {
			this.encuestaEjecutada = estado;
		});
	}

	ngOnDestroy(): void {
		if (this.subscriptor) {
			this.subscriptor.unsubscribe();
		}
	}

	getExpirationDate(): void {
		let tempDate = "";
		this._store
			.select((state) => state.alternatives.customerData.expirationDate)
			.subscribe((expirationDate) => {
				if (expirationDate !== "") {
					// Si la fecha es tipo yyyy/mm/dd, formatear a dd/mm/yy
					const isISODate = /^\d{4}\/\d{2}\/\d{2}$/.test(expirationDate.trim());
					if (isISODate) {
						const [yyyy, mm, dd] = expirationDate.trim().split('/');
						this.expirationDate = `${dd}/${mm}/${yyyy.slice(2)}`;
					} else {
						this.expirationDate = transformDateExpire(expirationDate);
					}
					tempDate = expirationDate;
				}
			});
		if (tempDate === "") {
			this._store
				.select(
					(state) =>
						state.maintenanceInfo.customerData
							.expirationDateFormatted
				)
				.subscribe((expirationDate) => {
					this.expirationDate = this.formatDate(expirationDate);
				});
		}
	}

	formatDate(date: string): string {
		return date.split("/").reverse().join("/");
	}

	cerrarModalConfirmar(event: boolean) {
		if (event) {
			this.closeModal.emit("");
		}
	}

	logoutMantenimientos() {
		const currentURL = document.location.href;
		const mantenimientosPaths = [
			"mantenimientos/listado-creditos",
			"mantenimientos/opcion-pago",
			"mantenimientos/nuevas-condiciones",
			"mantenimientos/otra-opcion",
			"mantenimientos/detalle",
			"mantenimientos/terminos-condiciones",
			"mantenimientos/confirmar-contacto",
			"mantenimientos/ingresar-email",
			"/new-aterrizaje",
			"/simular-ajuste",
			"/totalizador",
			"/nuevos-creditos",
			"/resumen",
			"/detalle-negociacion",
			"/TyC",
			"/correo-confirmacion",
			"/confirmacion-opcion"

		];
		if (mantenimientosPaths.some((path) => currentURL.includes(path))) {
			this.showSurvey();
		} else {
			this.exitExperience();
		}
	}

	showSurvey() {
		if (this.encuestaEjecutada) {
			this.exitExperience();
		}

		this.inicializarEncuesta();

		try {
			if (
				KAMPYLE_ONSITE_SDK &&
				typeof KAMPYLE_ONSITE_SDK.updatePageView === "function"
			) {
				KAMPYLE_ONSITE_SDK.updatePageView();
				this.configurarListenersEncuesta();
			}
		} catch (error) {
			this.exitExperience();
			throw error;
		}
	}

	private inicializarEncuesta(): void {
		window.scrollTo({ top: ZERO, behavior: "smooth" });
		window["userExit"] = true;
		window["IdCliente"] = this.documentNumber;
	}

	private configurarListenersEncuesta(): void {
		let encuestaMostrada = false;

		const salidaPorTimeoutId = setTimeout(() => {
			if (!encuestaMostrada) {
				this.exitExperience();
			}
		}, ENCUESTA_TIMEOUT_MS);

		window.addEventListener("MDigital_Form_Displayed", () => {
			encuestaMostrada = true;
			if (salidaPorTimeoutId) {
				clearTimeout(salidaPorTimeoutId);
			}
		});

		window.addEventListener("MDigital_Form_Close_No_Submit", () => {
			this.exitExperience();
		});

		window.addEventListener("MDigital_ThankYou_Close", () => {
			this.exitExperience();
		});
	}

	getDocument() {
		this.subscriptor = this._store
			.select((state) => state.autenticated.data)
			.subscribe((response) => {
				this.documentNumber = response.documentNumber;
			});
	}

	exitExperience() {
		this.mantenimientosService.logoutService().subscribe(() => {
			window.location.href =
				"https://www.bancolombia.com/personas/alternativas-financieras/negociar-deuda";
		});
	}
}
